var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('com-logo'),_c('div',{staticClass:"head-divide"}),_c('com-search'),(_vm.loggedin)?_c('com-inbox'):_vm._e(),(_vm.loggedin)?_c('com-groups'):_vm._e(),_c('com-account')],1)}
var staticRenderFns = []

export { render, staticRenderFns }